import React from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';

function Button({ as: Comp = 'button', isPrimary = true, isLarge = false, children, ...other}) {
    const className = classNames(styles.button, { 
        [styles.isPrimary]: isPrimary,
        [styles.isLarge]: isLarge 
    });

    return (
        <Comp className={className} {...other}>
            {children}
        </Comp>
    );
}

export default Button;